function getTempProduct() {
    return {
        isTemp: true,
        basket_added: false,
        basket_count: "0",
        description: "",
        discount_percent: "4.5",
        image: "https://sarfe.bpc.ir/image/cache/no_image-400x400.png",
        is_old_price: false,
        limit_count: 84,
        name: "Ù¾ÙØ¯Ø± Ø¯Ø³ØªÛ  Ø¬Ø¹Ø¨Ù 500 Ú¯Ø±ÙÛ Ø³ÙÙ¾Ø±Ø¨Ø±Ù",
        price: " 9,230 ØªÙÙØ§Ù ",
        price_price: 9230,
        product_id: "104",
        product_type: 1,
        special: " 8,819 ØªÙÙØ§Ù ",
        special_price: 8819,
        thumb: "https://sarfe.bpc.ir/image/cache/no_image-400x400.png",
        time: "108:20:53"
    }
}

export const groupedList = (list, rowLimitSize, emptyCount) => {
    let groupedList = []
    if (list.length > 0) {
        for (let i = 0; list.length; i += rowLimitSize) {
            if (i >= list.length) {
                break
            }
            let currentList = []
            for (let j = i; j < i + rowLimitSize; j++) {
                if (j >= list.length) {
                    if (emptyCount !== 0) {
                        for (let k = 0; k < emptyCount; k++) {
                            currentList.push(getTempProduct())
                        }
                    }
                    break
                }
                currentList.push(list[j])
            }
            groupedList.push(currentList)
        }
    }
    return groupedList
};